import type { ShippingAddress } from '@library/api-user'

const LOCALE_GB = 'en-GB'

const formatDeliveryDate = (date?: Date | string | null): string => {
  let newDate = date || new Date()

  if (typeof newDate === 'string' && ['null', 'undefined'].includes(newDate)) {
    newDate = new Date()
  }

  const dateToFormat = new Date(newDate)
  const pattern = new Intl.DateTimeFormat(LOCALE_GB, {
    dateStyle: 'full',
    timeZone: 'Europe/London',
  })

  try {
    const isoDate = new Date(dateToFormat.toISOString())
    const result = pattern.format(isoDate)

    return result
  } catch (e: any) {
    throw new Error(`Date formatting error "${date}": ${e.message}`)
  }
}

const formatShippingAddress = (address?: ShippingAddress): string => {
  if (!address) {
    return ''
  }

  const { line1, line2, line3, postcode } = address
  const orderedAddressItems = [line1, line2, line3, postcode].filter((line: string) => !!line)
  const result = orderedAddressItems.join(', ')

  return result
}

export { formatDeliveryDate, formatShippingAddress }
